import { useState, useEffect, useCallback } from "react";
import { toast } from "sonner";
import { conciergeApi, errMsg } from "@/components/concierge/api";
import { PersonForm } from "@/components/concierge/PersonForm";
import { PersonRow } from "@/components/concierge/PersonRow";

export const StaffSection = ({ onOpen }) => {
  const [staff, setStaff] = useState([]);

  const load = useCallback(async () => {
    const res = await conciergeApi.get("/staff");
    setStaff(res.data);
  }, []);

  useEffect(() => { load(); }, [load]);

  const add = async (form) => {
    try {
      await conciergeApi.post("/staff", form);
      toast.success("Personne ajoutée (30 € d'avoir)");
      load();
      return true;
    } catch (error) {
      toast.error(errMsg(error));
      return false;
    }
  };

  const remove = async (p) => {
    if (!window.confirm(`Retirer ${p.first_name} ${p.last_name} de la liste ? (ses bons restent dans l'historique)`)) return;
    await conciergeApi.delete(`/staff/${p.id}`);
    load();
  };

  return (
    <div className="space-y-4" data-testid="concierge-staff-section">
      <p className="text-sm text-slate-600">Personnel de la conciergerie — <strong>30 € d'avoir</strong> remis chaque 1er du mois.</p>
      <PersonForm onSubmit={add} prefix="staff" />
      <div className="space-y-2">
        {staff.map((p) => (
          <PersonRow key={p.id} person={p} onOpen={() => onOpen({ ...p, type: "staff" })} onDelete={() => remove(p)}
            badge={<span className="text-sm font-bold text-emerald-600" data-testid={`staff-credit-${p.id}`}>{p.credit.toFixed(2)} €</span>} />
        ))}
        {staff.length === 0 && <p className="text-center text-slate-400 py-6">Aucune personne</p>}
      </div>
    </div>
  );
};
